module.exports = __webpack_public_path__ + "static/img/wangji.bca30bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wangji.png
// module id = BFcf
// module chunks = 1